<template>
  <div>
    <page-header slot="header" @submit="handleSubmit" ref="header" />
    <page-main :table-data="table" :loading="loading" :isShow="isShow" @currentChange="exportPPT" />
    <js-pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        align="left"
        @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  components: {
    'PageHeader': () => import('./header'),
    'PageMain': () => import('./main')
  },
  data () {
    return {
      table: [],
      loading: false,
      isShow: true,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  created () {
    this.handleSubmit()
  },
  methods: {
    // 分页查询
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.handleSubmit()
      })
    },
    // 重载表格数据
    reload () {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit (form) {
      this.$api.exportPptGetList({
        ...form,
        ...this.page
      }).then(res => {
        this.page.pageTotal = res.body.count
        this.table = res.body.data
        if(this.table.length > 0){
          this.isShow = true
        }else{
          this.isShow = false
        }
      }).catch(() => {
      })
    },
    exportPPT (val) {
      this.$emit('exportPPT', val)
    }
  }
}
</script>
